module.exports = __webpack_public_path__ + "static/img/VDF.86ae00b8.jpg";